import { apiClient } from "../client";
import { ENDPOINTS } from "../endpoints";

export type DistributionPeriodPayload =
  | { period: "month"; month: string }
  | { period: "year"; year: number }
  | { period: "range"; startDate: string; endDate: string };

export interface GrantDistributionResponse {
  success?: boolean;
  message?: string;
  data?: unknown;
}

export const adminDistributionService = {
  grantDistribution: async (
    payload: DistributionPeriodPayload
  ): Promise<GrantDistributionResponse> => {
    const response = await apiClient.post<GrantDistributionResponse>(
      ENDPOINTS.ADMIN.GRANT_DISTRIBUTION,
      payload
    );
    return response.data;
  },
  tokenDistribution: async (
    payload: DistributionPeriodPayload
  ): Promise<GrantDistributionResponse> => {
    const response = await apiClient.post<GrantDistributionResponse>(
      ENDPOINTS.ADMIN.TOKEN_DISTRIBUTION,
      payload
    );
    return response.data;
  },
};

export default adminDistributionService;
